import React from 'react';
import ga from 'react-ga';

ga.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);

/**
 * Component that will look for the location change and tracks the page.
 */
export default class Analytics extends React.Component {
  componentDidMount() {
    this.trackPage(this.props.location.pathname, this.props.location.search)
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname
      || this.props.location.search !== prevProps.location.search) {
      this.trackPage(this.props.location.pathname, this.props.location.search)
    }
  }

  trackPage(pathname, search) {
    const page = pathname + search

    ga.set({ page });
    ga.pageview(page);
  }

  render() {
    return null;
  }
}

/**
 * Function to track specific events fired on certain action.
 */
export const trackEvent = ({ category, action, label }) => ga.event({ category, action, label });



// WEBPACK FOOTER //
// ./src/containers/Analytics.js